/* eslint-disable react/require-default-props */
import React from 'react';
import ExternalRoutes from 'services/external_routes';
import DashboardIcon from 'assets/images/menu/dashboard.svg';
import BulletinsIcon from 'assets/images/menu/bulletins.svg';
import BiddingOnlineSearchIcon from 'assets/images/menu/bidding-online-search.svg';
import FollowupOnlineSearchIcon from 'assets/images/menu/followup-online-search.svg';
import ManagementIcon from 'assets/images/menu/management.svg';
import DocumentsIcon from 'assets/images/menu/documents.svg';
import MonitoringIcon from 'assets/images/menu/monitoring.svg';
import DigitalSignatureIcon from 'assets/images/menu/digital-signature.svg';
import ImminenceIcon from 'assets/images/menu/imminence.svg';
import RobotIcon from 'assets/images/menu/robot.svg';
import DrLicitaIcon from 'assets/images/menu/drlicita-menu.svg';
import DefaultRoutes from 'services/private_routes';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MonitoringState } from 'store/modules/monitoring_store/types';
import ManagementPortalsIcon from 'assets/images/menu/management-portals.svg';
import createTrack from 'services/actions/tracker_actions';

interface SideBarItemProps {
  feature: string;
  representant: boolean;
  classTour?: string;
}

const featureIcon = (feature: string) => {
  // if (feature === 'Painel') return PanelIcon;
  if (feature === 'Boletins de Licitações') return BulletinsIcon;
  if (feature === 'Encontrar Licitações') return BiddingOnlineSearchIcon;
  if (feature === 'Encontrar Acompanhamentos') return FollowupOnlineSearchIcon;
  if (feature === 'Licitações Estratégicas') return ImminenceIcon;
  if (feature === 'Gerenciar Licitações') return ManagementIcon;
  if (feature === 'Gerenciar Documentos') return DocumentsIcon;
  if (feature === 'Assinatura Digital de Documentos') return DigitalSignatureIcon;
  if (feature === 'Dr. Licita') return DrLicitaIcon;
  if (feature === 'Monitorar Chat') return MonitoringIcon;
  if (feature === 'Gerenciar Portais') return ManagementPortalsIcon;
  if (feature === 'Robô de Lance Inteligente') return RobotIcon;
  if (feature === 'Robo de Lance Inteligente') return RobotIcon;
  return DashboardIcon;
};

const featureRoute = (feature: string) => {
  // if (feature === 'Painel') return ExternalRoutes.painel;
  if (feature === 'Boletins de Licitações') return ExternalRoutes.boletins;
  if (feature === 'Encontrar Licitações') return ExternalRoutes.licitacoes;
  if (feature === 'Encontrar Acompanhamentos') return ExternalRoutes.acompanhamentos;
  if (feature === 'Licitações Estratégicas') return ExternalRoutes.iminencia;
  if (feature === 'Gerenciar Licitações') return ExternalRoutes.gerenciar_licitacoes;
  if (feature === 'Gerenciar Documentos') return ExternalRoutes.documentos;
  if (feature === 'Assinatura Digital de Documentos') return ExternalRoutes.assinatura_digital;
  if (feature === 'Dr. Licita') return ExternalRoutes.dr_licita;
  if (feature === 'Monitorar Chat') return ExternalRoutes.monitoramento;
  if (feature === 'Gerenciar Portais') return ExternalRoutes.gerenciar_portais;
  if (feature === 'Robô de Lance Inteligente') return '/robo_lance';
  return ExternalRoutes.painel;
};

const SideBarItem = (props: SideBarItemProps) => {
  const { feature, representant, classTour } = props;
  const { monitoring, request } = useSelector<ApplicationState, MonitoringState>(
    (state) => state.storage.monitoring,
  );

  return (
    <li
      className={`nav-item ${
        window.location.pathname.includes(featureRoute(feature)) ? 'nav-current' : ''
      } ${classTour}`}
    >
      {DefaultRoutes.includes(featureRoute(feature)) && (
        <Link
          className={`nav-link ${representant ? 'representant' : '  '} databalloon`}
          aria-label={feature}
          data-balloon-pos="right"
          to={featureRoute(feature)}
          onClick={() => createTrack(`Menu - Clicou na ferramenta ${feature}`)}
        >
          <span className="nav-icon">
            <img alt={feature} src={featureIcon(feature)} />
          </span>
          {feature === 'Monitorar Chat' &&
            request?.get_notifications_unread?.loaded &&
            monitoring?.notifications_unread && (
              <span className="monitoring-notify position-absolute p-1 bg-danger border border-light rounded-circle" />
            )}
          <span className="nav-name">{feature}</span>
        </Link>
      )}

      {!DefaultRoutes.includes(featureRoute(feature)) && (
        <a
          className={`nav-link ${representant ? 'representant' : '  '} databalloon`}
          aria-label={feature}
          data-balloon-pos="right"
          href={featureRoute(feature)}
          onClick={() => createTrack(`Menu - Clicou na ferramenta ${feature}`)}
        >
          <span className="nav-icon">
            <img alt={feature} src={featureIcon(feature)} />
          </span>
          <span className="nav-name">{feature}</span>
        </a>
      )}
    </li>
  );
};

export default SideBarItem;
